/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card style="box-shadow: none !important;">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <ValidationObserver ref="observer">
            <form action="#">
              <div class="form-row" >
                <div class="col-md-12 mb-3">
                  <label for="session_hosting_platform s-heading">Meeting PlatForm</label>
                  <select v-model="vmSpcmCalendarFormData.calendar_hosting_platform" class="form-control" id="session_hosting_platform">
                    <option v-for="(platform, index) in SPCMSessionHostingPlatForm" :key="index" :value="platform">
                      {{ platform }}
                    </option>
                  </select>
                  <small class="primary-color">* If you choose historic meeting then it will not create a meeting request on the google calendar. Also no communication will be sent.</small>
                </div>

                <div class="col-12 mb-3" v-if="propActivity">
                  <label for="validationslot_duration">
                    {{cvCounsellorEventTitleLabel}}</label
                  >
                  <input
                    v-model="vmSpcmCalendarFormData.title"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-12 mb-3" v-if="propActivity">
                    <label for="validationslot_duration">
                      {{cvCounsellorEventDescLabel}}</label
                    >
                    <textarea
                      v-model="vmSpcmCalendarFormData.description"
                      type="text"
                      class="form-control textarea"
                      required
                    ></textarea>
                </div>
                <div class="col-12 mb-3" v-if="propActivity">
                    <label for="validationslot_duration">
                      {{cvCounsellorEventCategoryabel}}</label
                    >
                  <select v-model="vmSpcmCalendarFormData.category_name" class="form-control">
                    <option :value="null" disabled>Choose Category</option>
                    <option :value="null">All</option>
                    <option v-for="(category, index) of spcmCalendarCategory" :key="(index+1)" :value="category.category_name">
                      {{ category.category_name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3" v-if="userData.user_role == 'USERROLE11111'">
                    <label for="validationcounsellor_id">
                      {{cvCounsellorsList}}</label>
                    <ValidationProvider name="counsellor name" rules="required" v-slot="{ errors }" ref="counsellorAdd">
                    <multiselect
                      v-model="vmSpcmCalendarFormData.counsellor_id"
                      :tag-placeholder="cvSelectLabel"
                      :placeholder="cvSelectLabel"
                      :searchable="true"
                      class="multiselect_group"
                      label="user_name"
                      track-by="user_name"
                      :options="counsellorObjList"
                      >
                    </multiselect>
                    <span style="color:red">{{ errors[0] }}</span>
                  </ValidationProvider>

                </div>
                <div class="col-md-12 mb-3" v-else>
                  <ValidationProvider name="counsellor name" rules="required" v-slot="{ errors }" ref="counsellorAdd">
                    <label for="validationcounsellor_id">
                      {{ cvCounsellorLabel }}</label
                    >
                    <p>{{ userData.user_name }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3" v-if="propActivity">
                  <label for="validation_date">{{ cvSlotDate }}</label>
                  <div class="w-200px">
                    <datetime
                      type="date"
                      v-model="vmStartDate"
                      input-class="gide_datetime_input"
                      class="datetime-theme-primary"
                      format="dd-MM-yyyy"
                      :phrases="{ok: 'Continue', cancel: 'Exit'}"
                      auto
                    ></datetime>
                  </div>
                </div>

                <div class="col-md-12 mb-3" v-else>
                  <label for="validation_range">{{ cvDateRange }}</label>
                  <div class="dateRange">
                    <date-range-picker
                      ref="picker"
                      :show-dropdowns="true"
                      class="w-100"
                      :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }"
                      v-model="whereFilter.dateRange"
                    ></date-range-picker>
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="!propActivity">
                  <label for="">{{ cvSessionDays }}</label>
                  <b-form-checkbox-group
                    id="checkbox-group-1"
                    v-model="selectedDays"
                    :options="weekDays"
                    name="flavour-1"
                    ></b-form-checkbox-group>
                    <span>{{ weekDaysArrayIsEmpty ? 'Select atleast a day' : '' }}</span>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="validationslot_start_ts">
                      {{cvSlotStartTimeLabel}}</label
                    >
                    <ValidationProvider rules="required" v-slot="{ errors }">
                    <datetime
                      type="time"
                      v-model="vmSpcmCalendarFormData.slot_start_ts"
                       input-class="gide_datetime_input"
                      class="datetime-theme-primary"
                      :format="{ hour: 'numeric', minute: '2-digit'}"
                      :phrases="{ok: 'Continue', cancel: 'Exit'}"
                      :hour-step="1"
                      :minute-step="5"
                      :week-start="7"
                      use12-hour
                      auto
                      :min-datetime="minStartDate"
                    ></datetime>
                    <span>{{ errors[0] ? 'Time slot cannot be empty' : '' }}</span>
                  </ValidationProvider>
                </div>
                <div class="col-6 mb-3">
                  <label for="validationslot_duration">
                    {{cvSlotDurationLabel}}</label
                  >
                  <input
                    v-model="vmSpcmCalendarFormData.slot_duration"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validation_chooseDate">Meeting Weblink</label>
                  <input
                    v-model="vmSpcmCalendarFormData.calendar_meeting_link"
                    type="text"
                    class="form-control"
                    id="validation_session_weblink"
                  />
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                  <label>
                    <input class="mr-2" v-model="vmSpcmCalendarFormData.isParentAllow" type="checkbox">{{ cvIsParentAllow }}
                  </label>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validation_cc_email">CC Email</label>
                  <input
                    v-model="vmSpcmCalendarFormData.cc_email"
                    type="text"
                    class="form-control"
                    id="validation_cc_email"
                    placeholder="Enter comma-separated email addresses"
                  />
                  <small class="text-muted">* Comma-separated values will be used for reminder emails and Google Calendar</small>
                </div>
              </div>

              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="spcmCalendarAdd()"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  label{
    text-transform: capitalize;
  }
</style>
<script>
import { SpcmCalenders } from "../../../FackApi/api/SpcmCalender.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import Multiselect from "vue-multiselect"
import "vue-datetime/dist/vue-datetime.css"
import { Datetime } from "vue-datetime"
import { User } from "../../../FackApi/api/user.js"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import userPermission from "../../../Utils/user_permission.js"
import { SpcmCounsellors } from "../../../FackApi/api/SpcmCounsellor.js"
import { SpcmCalendarCategorys } from "../../../FackApi/api/SpcmCalendarCategory.js"
import moment from "moment"
import SPCMSessionHostingPlatForm from "../../../FackApi/json/SPCMSessionHostingPlatForm.json"

export default {
  name: "SpcmCalenderAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propUserId: {
      type: String
    },
    propActivity: {
      type: Boolean,
      default: false
    },
    propSpcmId: {
      type: String,
      default: ""
    }
  },
  components: {
    Datetime,
    Multiselect,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      apiName: "spcm_calendar_add",
      cvCardTitle: "Add Spcm Calendar",
      cvCardSubHeader: "Add Spcm Calendar",
      cvCounsellorEventTitleLabel: "Title",
      cvCounsellorEventCategoryabel: "Category",
      cvCounsellorEventDescLabel: "Description",
      weekDaysArrayIsEmpty: false,
      cvCounsellorLabel: "Counsellor",
      cvSubmitBtn: "Add",
      cvSelectLabel: "Counselor Name",
      cvSessionDays: "Session for days",
      cvCounsellorsList: "counsellor name",
      // cvSlotStartTsLabel: "slot start ts",
      cvSlotDate: "Date",
      cvDateRange: "Select Date Range",
      minStartDate: "",
      cvSlotDurationLabel: "slot duration (in sec)",
      cvSlotStartTimeLabel: "time",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Spcm Calender Add Response",
      cvIsParentAllow: "Add Parent to this meeting",
      vmSpcmCalendarFormData: Object.assign({}, this.initFormData()),
      vmSpcmCalenderDesc: null,
      vmSpcmCalenderType: null,
      cvCounsellorOptions: [],
      counsellorObjList: [],
      spcmCalendarCategory: [],
      counsellor_id: {},
      vmStartDate: "",
      SPCMSessionHostingPlatForm: SPCMSessionHostingPlatForm,
      whereFilter: {
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        }
      },
      weekDays: [
        { text: "Monday", value: "MON" },
        { text: "Tuesday", value: "TUE" },
        { text: "Wednesday", value: "WED" },
        { text: "Thursday", value: "THU" },
        { text: "Friday", value: "FRI" },
        { text: "Saturday", value: "SAT" },
        { text: "Sunday", value: "SUN" }
      ],
      selectedDays: []
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    await this.spcmCalendarListId()
    await this.SpcmCalendarCategoryList()
    this.spcmCounsellorList()
    this.getCounsellorList()
  },
  methods: {
    /**
     * initFormData
     */
    formatDate (date) {
      if (!date) return ""
      // Using moment since it is already imported in your file
      return moment(date).format("DD-MM-YYYY")
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        "counsellor_id": "",
        "slot_start_ts": "",
        "slot_duration": "3600",
        "category_name": null,
        "title": "",
        "description": "",
        "calendar_hosting_platform": "",
        "calendar_meeting_link": "",
        "cc_email": "",
        "isParentAllow": false
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSpcmCalendarFormData) {
          if (!this.vmSpcmCalendarFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * spcmCalendarAdd
     */
    async spcmCalendarAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      if (this.userData.user_role == "USERROLE11118") {
        this.vmSpcmCalendarFormData.counsellor_id = this.userData.user_id
      }
      else {
        const isValid = await this.$refs.counsellorAdd.validate()
        if (!isValid.valid) {
          return
        }

        this.$refs.observer.validate().then((success) => {
          if (success) {
            console.error("FORM INVALID")
          }
          else {
            console.error("FORM VALID")
          }
        })
      }

      if (this.selectedDays.length == 0) {
        this.weekDaysArrayIsEmpty = true
      }
      else {
        this.weekDaysArrayIsEmpty = false
      }
      try {
        this.cvLoadingStatus = true
        this.vmSpcmCalendarFormData.counsellor_id = this.vmSpcmCalendarFormData.counsellor_id.counsellor_user_id ? this.vmSpcmCalendarFormData.counsellor_id.counsellor_user_id : this.userData.user_id

        // --- UPDATED LOGIC FOR ALTERNATIVE DATE SELECTION ---
        let startDate, endDate

        if (this.propActivity) {
          // Case 1: Specific Date (Single Date Picker)
          let selectedDate = moment(this.vmStartDate).format("YYYY-MM-DD")
          startDate = selectedDate
          endDate = selectedDate
        }
        else {
          // Case 2: Date Range (Range Picker)
          startDate = moment(this.whereFilter.dateRange.startDate).format("YYYY-MM-DD")
          endDate = moment(this.whereFilter.dateRange.endDate).format("YYYY-MM-DD")
        }

        let payload = {
          spcm_id: this.propSpcmId,
          counsellor_id: this.vmSpcmCalendarFormData.counsellor_id,
          title: this.vmSpcmCalendarFormData.title,
          user_id: this.propUserId,
          category: this.vmSpcmCalendarFormData.category_name,
          description: this.vmSpcmCalendarFormData.description,
          slot_duration: this.vmSpcmCalendarFormData.slot_duration,
          slot_start_ts: this.vmSpcmCalendarFormData.slot_start_ts,
          calendar_hosting_platform: this.vmSpcmCalendarFormData.calendar_hosting_platform,
          calendar_meeting_link: this.vmSpcmCalendarFormData.calendar_meeting_link,
          cc_email: this.vmSpcmCalendarFormData.cc_email,
          date_range: [startDate, endDate],
          selected_week_days: this.selectedDays,
          isParentAllow: !!this.vmSpcmCalendarFormData.isParentAllow
        }

        let spcmcalendarAddResp = await SpcmCalenders.spcmCalendarAdd(this, payload)
        await ApiResponse.responseMessageDisplay(this, spcmcalendarAddResp)
        if (spcmcalendarAddResp && !spcmcalendarAddResp.resp_status) {
          return false
        }
        this.$emit("emitAddsessions", spcmcalendarAddResp.resp_data)
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseSpcmCalenderAddModal")
        }
        this.vmSpcmCalendarFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at spcmcalendarAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * getCounsellorList
     */
    async getCounsellorList () {
      const payload = {
        user_role: "USERROLE11118" // counsellor
      }
      const apiResp = await User.userListSearch(this, payload)
      if (apiResp.resp_status) {
        this.cvCounsellorOptions = apiResp.resp_data.data
      }
    },
    /**
     * setCounsellorListFilters
    */
    async spcmCounsellorList () {
      const counselorsListResp = await SpcmCounsellors.spcmCounsellorList()
      if (counselorsListResp.resp_status) {
        this.counsellorObjList = counselorsListResp.resp_data.data
      }
    },
    /**
     * SpcmCalendarCategory List
     */
    async SpcmCalendarCategoryList () {
      try {
        let SpcmCalendarCategoryListResp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this)
        if (SpcmCalendarCategoryListResp.resp_status) {
          this.spcmCalendarCategory = SpcmCalendarCategoryListResp.resp_data.data
          this.showLoadMoreBtn = true
        }
        else {
          this.toastMsg = SpcmCalendarCategoryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryList() and Exception:", err)
      }
    },
    /**
     * spcmCalendarListId
     */
    async spcmCalendarListId () {
      try {
        let payload = {
          spcm_student_id: this.propUserId
        }
        let spcmCalendarLastIdResp = await SpcmCalenders.spcmCalendarLastId(this, payload)
        const spcmCalendarObj = spcmCalendarLastIdResp.resp_data.data
        if (spcmCalendarObj[0].calendar_meeting_link) {
          this.vmSpcmCalendarFormData.calendar_meeting_link = spcmCalendarObj[0].calendar_meeting_link
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCalendarListId() and Exception:", err.message)
      }
    }
  }
}
</script>
<style>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
